import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { tracking } from '../util/tracking';

let lastTrackedPath: string | null = null;

export const useRecordPageView = () => {
  const location = useLocation();

  useEffect(() => {
    const pathKey = `${location.pathname}${location.search}${location.hash}`;
    if (lastTrackedPath === pathKey) return;
    lastTrackedPath = pathKey;

    const run = async () => {
      try {
        await tracking.log('INTERNAL', 'page_view', {
          path: location.pathname,
          search: location.search,
          hash: location.hash,
        });
      } catch {
        // intentionally ignore tracking errors
      }
    };

    run();
  }, [location.pathname, location.search, location.hash]);
};
